// extracted by mini-css-extract-plugin
export default {"wrapper":"OS-z","availablePromoMessagesLabel":"PS-z","promoMessageList":"QS-z","promoMessage":"RS-z","appliedPromoMessage":"SS-z","promoMessageAmount":"TS-z"};